import React, { useEffect, useRef, useState } from 'react';
import styles from '../CSS/AgentHome.module.css';
import '../CSS/Home.css'

import Loading from '../Components/Loading';
import Error from '../Components/Error';

import { useAuth } from '../AuthContext';
import { useNavigate } from 'react-router-dom';

import GiftGenerator from '../Components/GiftGenerator';

const Home = () => {
    const navigate = useNavigate();

    const { user, fetchData, postData } = useAuth();

    const [records, setRecords] = useState([]);

    const [balance, setBalance] = useState({
        usdt: 0,
        trx: 0
    });

    const [betting, setBetting] = useState(0);
    const [winning, setWinning] = useState(0)

    const [deposit, setDeposit] = useState({
        usdt: 0,
        trx: 0
    });

    const [withdraw, setWithdraw] = useState({
        amount: 0,
        no: 0
    });



    const [loader, setLoader] = useState(false);
    const [isError, setIsError] = useState(false);
    const [errorText, setErrorText] = useState('');

    const [giftScreen, setGiftScreen] = useState(false)
    const [generatedCode, setGeneratedCode] = useState('')
    const [popupError, setPopupError] = useState({
        isError: false,
        message: ''
    })

    const displayError = (message) => {
        setIsError(true);
        setErrorText(message);

        const timerId = setTimeout(() => {
            setIsError(false);
            setErrorText('');
        }, 1500);

        return () => clearTimeout(timerId);
    };

    const isFirstRun = useRef(true);
    async function getData() {
        setLoader(true);

        try {
            const data = await fetchData('/admin/main');
            setLoader(false);

            setBalance(data.balance);
            setDeposit(data.deposits);
            setWithdraw(data.withdrawals);
            setBetting(data.betting);
            setWinning(data.winnings)

            setRecords(data.records || [])
        } catch (error) {
            setLoader(false);
            displayError(error.message)
        }
    }

    useEffect(() => {
        if (isFirstRun.current) {
            getData();
            isFirstRun.current = false;
        }
    }, [])

    async function generateCode(prop1, prop2) {
        if (user.role !== 'admin') return;

        setLoader(true);

        try {
            const data = await postData('/admin/generate/gift', { amount: prop1, size: prop2 });
            setLoader(false);

            setGeneratedCode(data.code);

            setPopupError({
                isError: true
            })
        } catch (error) {
            setLoader(false);
            setPopupError({
                isError: true,
                message: error.message
            })
        }
    }


    return (
        <div className={styles.dashboard}>
            {giftScreen && <GiftGenerator onRedeemCode={generateCode} error={popupError} generatedCode={generatedCode} closePopup={() => setGiftScreen(false)} />}

            {loader && <Loading />}
            {isError && <Error errorMsg={errorText} />}

            <div className={styles.topbar}>
                <div className={styles.left}>
                    <h1>Dashboard</h1>
                </div>
                <div className={styles.right}>
                    <div className={styles.avatar}>U</div>
                </div>
            </div>

            <div className={styles['summary-container']}>
                <div className={styles['summary-card']}>
                    <p className={styles['summary-title']}>Available Balance</p>
                    <h2 className={styles['summary-amount']}>${balance.usdt} <span>USD</span></h2>
                    <p className={styles['summary-sub']}>Tron: {balance.trx} TRX</p>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Total Deposits</p>
                    <h2 className={styles['summary-amount']}>${deposit.usdt} <span>USD</span></h2>
                    <p className={styles['summary-sub']}>Tron: {deposit.trx} TRX</p>
                </div>
                <div className={styles['summary-card']}>
                    <p className={styles['summary-title']}>Total Withdrawals</p>
                    <h2 className={styles['summary-amount']}>${withdraw.usdt} <span>USD</span></h2>
                    <p className={styles['summary-sub']}>Tron: {withdraw.trx} TRX</p>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Total Betting's</p>
                    <h2 className={styles['summary-amount']}>${betting} <span>USD</span></h2>
                </div>
                <div className={`${styles['summary-card']} ${styles.small}`}>
                    <p className={styles['summary-title']}>Total Winning's</p>
                    <h2 className={styles['summary-amount']}>${winning} <span>USD</span></h2>
                </div>
            </div>

            <div className={styles['button-group']}>
                <button onClick={() => navigate('/records/users')}>User Records</button>
                <button onClick={() => navigate('/records/payouts')}>Withdrawal Records</button>
                <button onClick={() => navigate('/records/deposits')}>Deposit Records</button>
                <button onClick={() => navigate('/records/bets')}>Bet Records</button>
                <button onClick={() => navigate('/pending/withdrawal')}>Pending Withdrawals</button>
            </div>

            <div className="new-actions-section">
                <div className="action-button add-funds" onClick={() => navigate('/update/balance')}>
                    <span className="icon">+</span>
                    <span className="text">Add Funds</span>
                </div>
                <div className="action-button upcoming-fixtures" onClick={() => navigate('/fixtures')}>
                    <span className="icon">📅</span>
                    <span className="text">Upcoming Fixtures</span>
                </div>
            </div>

            <div className={styles['daily-records']}>
                <h3>Daily Overview</h3>
                <table>
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Users</th>
                            <th>Deposit</th>
                            <th>Withdraw</th>
                            <th>Bets</th>
                            <th>Winnings</th>
                            <th>Profit</th>
                        </tr>
                    </thead>
                    <tbody>
                        {records.map((item, index) => {
                            const deposits = item.usdtDeposits;
                            const payouts = item?.usdtPayouts;

                            return (
                                <tr key={index}>
                                    <td>{item.date}</td>
                                    <td>{item.users}</td>
                                    <td>${deposits}</td>
                                    <td>${payouts}</td>
                                    <td>${item.bets}</td>
                                    <td>${item.returns}</td>
                                    <td>${parseFloat((deposits - payouts).toFixed(2)).toLocaleString()}</td>
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default Home